import React, { useEffect, useState } from 'react';
import {useLocation, useParams} from 'react-router-dom';
import axios from 'axios';
import {Advertisement, Link, LinkCollection} from "./Home";
import Header from "./Header";
import {Box, Card, CardContent, CardMedia, Container} from "@mui/material";
import Typography from "@mui/material/Typography";
import {API_BASE_URL} from "./SignUp";
import {Footer} from "./Footer";
import {MoveToTop} from "./MoveToTop";

const CollectionDetail: React.FC = () => {
    const location = useLocation();
    const [collection, setCollection] = useState<LinkCollection | null>(null);
    const [loading, setLoading] = useState(true);
    const collectionId = location.state!.id;
    const [topAdvertisements, setTopAdvertisements] = useState([]);
    const [isMobile, setIsMobile] = useState(false);

    const handleResize = () => {
        setIsMobile(window.innerWidth < 768); // 768px 이하를 모바일로 간주
    };
    const updateViewCount = async (linkId: number) => {
        await fetch(`${API_BASE_URL}/links/${linkId}/view`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
        });
    };

    const fetchCollectionDetail = async () => {
        if (!collectionId) {
            setLoading(false);
            return;
        }

        try {
            const response = await fetch(`${API_BASE_URL}/link-collections/${collectionId}`);
            if (!response.ok) {
                throw new Error('Failed to fetch collection details');
            }
            const data = await response.json();

            // 링크를 ranking에 따라 오름차순으로 정렬
            const sortedLinks = data.links.sort((a: Link, b: Link) => a.ranking - b.ranking);

            // 정렬된 링크를 상태에 설정
            setCollection({ ...data, links: sortedLinks });
            // setCollection(data);
        } catch (error) {
            console.error('Error fetching collection details:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleLinkClick = async (linkId: number, linkUrl: string) => {
        try {
            await updateViewCount(linkId);

            window.open(linkUrl, '_blank');
            await fetchCollectionDetail()
        } catch (error) {
            console.error('Error updating view count:', error);
        }
    };

    function fetchAdvertisements() {
        axios.get(`${API_BASE_URL}/advertisements`)
            .then(response => {
                // setAdvertisements(response.data);

                const allAnnouncements = response.data;

                // position이 'top'인 광고와 'side'인 광고를 나눠서 상태에 저장
                const topAdvertisements = allAnnouncements.filter((ad: { position: string; }) => ad.position === 'top');

                // 상태에 저장 (필요한 대로 변경)
                setTopAdvertisements(topAdvertisements);
                setLoading(false);
            })
            .catch(error => {
                console.error('Error fetching the link-collections data:', error);
                setLoading(false);
            });
    }

    useEffect(() => {
        fetchCollectionDetail();
        fetchAdvertisements();

        handleResize(); // 초기 체크
        window.addEventListener('resize', handleResize); // 리사이즈 이벤트 리스너 등록

        return () => {
            window.removeEventListener('resize', handleResize); // 리스너 정리
        };
    }, [collectionId]);

    const getFormattedDate = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = today.getMonth() + 1; // 월은 0부터 시작하므로 +1
        const date = today.getDate();
        const dayNames = ['일', '월', '화', '수', '목', '금', '토'];
        const day = dayNames[today.getDay()]; // 요일 가져오기

        return `${year}년 ${month}월 ${date}일 [${day}]`;
    };

    const addBookmark = () => {
        alert("Ctrl+D 혹은 Command+D 를 눌러서 이 페이지를 즐겨찾기에 추가하세요.");
    };

    return (
        <>
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                minHeight: '100vh'
            }}>
                {!isMobile &&
                    <div style={{paddingLeft: '23%', paddingTop: '1rem', textAlign: 'left'}}>
                        <a href="#" onClick={addBookmark} style={{textDecoration: 'none', color: 'black'}}>즐겨찾기 추가</a>
                        <span style={{margin: '0 10px'}}>/</span>
                        <span>{getFormattedDate()}</span>
                    </div>
                }
                <Header/>

                {/*서치엔진 상단 링크*/}
                {/*<div style={{*/}
                {/*    display: 'flex',*/}
                {/*    flexWrap: 'wrap',*/}
                {/*    justifyContent: 'flex-start',*/}
                {/*    marginBottom: '1rem',*/}
                {/*    maxWidth: '1200px',*/}
                {/*    margin: 'auto'*/}
                {/*}}>*/}
                {/*    {topAdvertisements.map((ad: Advertisement, index) => (*/}
                {/*        <div key={index} style={{display: 'inline-block', margin: '5px'}}>*/}
                {/*            <a href={ad.link} target="_blank" rel="noopener noreferrer">*/}
                {/*                <div*/}
                {/*                    style={{*/}
                {/*                        width: '288.5px',*/}
                {/*                        height: '78.39px',*/}
                {/*                        backgroundColor: '#f0f0f0',*/}
                {/*                        display: 'flex',*/}
                {/*                        justifyContent: 'center',*/}
                {/*                        alignItems: 'center',*/}
                {/*                        cursor: 'pointer',*/}
                {/*                        borderRadius: '4px',*/}
                {/*                        overflow: 'hidden',*/}
                {/*                    }}*/}
                {/*                >*/}
                {/*                    {ad.image ? (*/}
                {/*                        <img*/}
                {/*                            src={`data:image/png;base64,${ad.image}`}*/}
                {/*                            style={{width: '100%', height: '100%', objectFit: 'cover'}}*/}
                {/*                        />*/}
                {/*                    ) : (*/}
                {/*                        '이미지 없음'*/}
                {/*                    )}*/}
                {/*                </div>*/}
                {/*            </a>*/}
                {/*        </div>*/}
                {/*    ))}*/}
                {/*</div>*/}

                <div className='advertisement-container' style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    justifyContent: 'flex-start',
                    marginBottom: '1rem',
                    maxWidth: '1200px',
                    margin: 'auto'
                }}>
                    {topAdvertisements.map((ad: Advertisement, index) => (
                        <div key={index} style={{display: 'inline-block', margin: '5px'}}>
                            <a href={ad.link} target="_blank" rel="noopener noreferrer">
                                <div
                                    className="ad-banner"
                                    style={{
                                        width: '288.5px',
                                        height: '78.39px',
                                        // backgroundColor: '#f0f0f0',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        cursor: 'pointer',
                                        borderRadius: '4px',
                                        overflow: 'hidden',
                                    }}
                                >
                                    {ad.image ? (
                                        <img className='top-banner'
                                             src={`data:image/png;base64,${ad.image}`}
                                             style={{width: '100%', height: '100%', objectFit: 'cover'}}
                                        />
                                    ) : (
                                        '이미지 없음'
                                    )}
                                </div>
                            </a>
                        </div>
                    ))}
                </div>


                <Container style={{
                    maxWidth: '1200px',
                    height: '70px',
                    margin: '0 auto',
                    // padding: '0 50px',
                    overflowX: 'auto',
                    border: '1px solid #d3d3d3',
                    borderRadius: '4px',
                    display: 'flex',
                    alignItems: 'center',
                }}>
                    {collection !== null && collection.image && (
                        <img
                            src={`data:image/png;base64,${collection.image}`}
                            style={{
                                width: '50px',
                                height: '50px',
                                marginRight: '8px',
                                verticalAlign: 'middle'
                            }}
                        />
                    )}
                    <h1>{collection !== null && collection.name}</h1>
                </Container>

                <div style={{display: 'flex', flexWrap: 'wrap', justifyContent: 'center'}}>
                    <Box
                        className='card-container'
                        display="flex"
                        flexWrap="wrap"
                        justifyContent="flex-start"
                        padding="16px"
                        style={{maxWidth: '1100px'}}
                    >
                        {collection !== null && collection.links.map(link => {
                            return (
                                <Card
                                    className="responsive-card"
                                    id="responsive-detail-card"
                                    key={link.id}
                                    sx={{
                                        width: '210px',
                                        margin: '5px',
                                        cursor: 'pointer',
                                        boxShadow: 3,
                                        transition: 'transform 0.2s',
                                        '&:hover': {
                                            transform: 'scale(1.05)',
                                        },
                                    }}
                                    onClick={() => handleLinkClick(link.id, link.link)}
                                >
                                    <CardMedia
                                        component="img"
                                        height="140"
                                        image={`data:image/png;base64,${link.image}`} // 기본 이미지 설정
                                        alt={link.name}
                                        sx={{objectFit: 'cover'}}
                                    />
                                    <CardContent style={{
                                        backgroundImage: 'url("/link/link-background.png")',
                                        backgroundSize: 'cover',
                                        backgroundPosition: 'center',
                                        alignItems: 'center',
                                        justifyItems: 'center',
                                        justifyContent: 'center',
                                        backgroundRepeat: 'no-repeat',
                                        color: 'white'
                                    }}>
                                        <Typography variant="h6" component="div">
                                            {link.ranking <= 10 && (
                                                <img
                                                    src={`/link/crowns-v3/crown-${link.ranking}.png`}
                                                    style={{
                                                        backgroundSize: 'cover',
                                                        backgroundPosition: 'center',
                                                        width: '20px',
                                                        height: '20px',
                                                        marginRight: '8px'
                                                    }}
                                                />
                                            )}
                                            {link.name}
                                        </Typography>
                                        {/* <Typography variant="body2" color="white">
                                            조회수: {link.viewCount}
                                        </Typography> */}
                                    </CardContent>
                                </Card>
                            )
                        })}
                    </Box>
                </div>
                <Footer/>
                <MoveToTop/>
            </div>
        </>
    );
};

export default CollectionDetail;
